export enum SendEmailAction {
  PurchaseOrderCreate = 'purchaseOrderCreate',
  PurchaseOrderUpdate = 'purchaseOrderUpdate',
}
